import { View } from "extensions/marionette";

import loader from "common/helpers/horizontal-loader.jst";

export const LoadingPageView = View.extend({
    attributes: {
        style: "min-height: calc(100vh - 142px)"
    },
    template: loader
});
